import ChangeHeader from '@/components/shared/table/ChangeHeader'
import { translateList } from '@/utils/utils'

export var headerMixin = {
  components: {
    ChangeHeader,
  },
  data: () => {
    return {
      changeHeaderDialog: false,
    }
  },
  computed: {
    tableHeaderSelected() {
      const header = translateList(this.tableHeaderAvaiable)

      return header.filter((header) => {
        return header.show
      })
    },
  },
  methods: {
    mountHeader() {
      if (localStorage.getItem('headersController')) {
        let headersControl = JSON.parse(
          localStorage.getItem('headersController')
        )
        headersControl.forEach((header) => {
          if (header[header.length - 1] === this.headerName) {
            let savedHeader = header
            this.tableHeaderAvaiable.forEach((header) => {
              header.show = savedHeader.find((element) => {
                return element === header.text
              })
            })
          }
        })
      }
    },
  },
}
